const mapping: Record<string, string> = {
  id: 'p=>p.Id',
  name: 'p=>p.Name',
}

export const mapSortRoleParam = (key: string) => mapping[key]
